export default "__VITE_ASSET__BGJifZBD__"